<template>
  <v-card outlined class="py-2" color="amber lighten-4">
    <div v-show="!informationList.length&&!overlayStepper1" align="center" class="caption grey--text my-4">
      <v-icon small color="grey">mdi-information-outline</v-icon>
      只今お知らせはありません
    </div>
    <template v-for="items of informationList">
        <v-row dense v-bind:key="items.id">
        <v-col dense cols="12" class="pa-0 mb-0">
          <span class="body ml-4">{{ items.NoticeFrom }}</span>

          <v-chip class="mx-2" color="red" text-color="white" small v-if="items.Type == '障害発生'">{{ items.Type }}</v-chip>
          <v-chip class="mx-2" color="light-blue" text-color="white" small v-else-if="items.Type == '障害復旧'">{{ items.Type }}</v-chip>
          <v-chip class="mx-2" color="red" text-color="white" small v-else-if="items.Type == '重要なお知らせ'">{{ items.Type }}</v-chip>
          <v-chip class="mx-2" color="green" text-color="white" small v-else>{{ items.Type }}</v-chip>
<!--
          <span class="caption ml-2">{{ items.Message }}</span>
-->
           <span class="body" v-html="items.Message" @click="openInfoDetail(items.id, items.Order)"></span>
        </v-col>
      </v-row>
    </template>

    <v-sheet
      class="pa-2"
      v-show="overlayStepper1"
    >        
      <v-skeleton-loader
        class="mx-auto"
        type="paragraph"
      ></v-skeleton-loader>
    </v-sheet>

    <info-detail-dialog ref="infoDetail"></info-detail-dialog>
  </v-card>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
// import { listInformations } from '../graphql/queries'
//import { searchInformations } from '../graphql/queries'
import { sortedlistInformations } from '../graphql/queries'
import InfoDetail from "./InformationDetail.vue"

export default {
  name: 'ApplicationList',
  data() {
    return {
      informationList: [],
      overlayStepper1: true,
      selectInfomationID: ""
    }
  },
  components: {
    infoDetailDialog: InfoDetail,
  },
  mounted: async function () {
    console.log("mounted start");
    var now = new Date();
    var yyyy = now.getFullYear();
    var mm = ("00" + (now.getMonth()+1)).slice(-2);
    var dd1 = ("00" + (now.getDate()-1)).slice(-2);
    var dd2 = ("00" + (now.getDate()+1)).slice(-2);
    var today1 = yyyy + "-" + mm + "-" + dd1;
    var today2 = yyyy + "-" + mm + "-" + dd2;
    console.log("now", now)

    //gte（以上）、lte（以下）がなぜか使えないので、1日前より大きい、1日後より小さいで検索
    let infoFilter = {
      and: [{
        NoticeTo:{
          gt: today1
        },
        NoticeFrom:{
          lt: today2
        },
      }
      ]
    }
    let informations = await API.graphql(graphqlOperation(sortedlistInformations, {limit: 100, isActive: '1', filter:infoFilter}))
    console.log("informations:",informations);
    this.informationList = informations.data.sortedlistInformations.items
    this.overlayStepper1 = false
  },
  computed : {
  },
  methods: {
    openInfoDetail(id, order) {
      this.$refs.infoDetail.open(id, order);
    }
  },
}
</script>